import { asteriskTextFormatting } from "../helpers/FormattingHelper"

const ArticleColorUsp = ({ modifier = "", titleBoxColor, titleBoxTextColor, uspBoxColor, uspBoxTextColor, title, headline, uspTexts }) => {
  const titleBoxStyle = { "--title-box-color": titleBoxColor, "--title-box-text-color": titleBoxTextColor }
  const containerStyle = { "--usp-box-color": uspBoxColor, "--usp-box-text-color": uspBoxTextColor }

  return (
    <div className={modifier}>
      <div className="usp-container" style={containerStyle}>
        <div className="titlebox" style={titleBoxStyle}>
          {title}
        </div>
        <div className="textcontainer">
          <div className="textboxhead" dangerouslySetInnerHTML={{ __html: headline }}></div>
          {uspTexts && uspTexts.length > 0 ? (
            <ul className="uspbox">
              {uspTexts.map((usp, index) => (
                <li key={index}>{asteriskTextFormatting(usp)}</li>
              ))}
            </ul>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  )
}

export default ArticleColorUsp
